import 'src/types/types'

/**
 * @param {string} url
 * @param {Record<string, string>} params
 * @param {ApiUrlOptions} [options]
 * @returns {string}
 */
export const urlWithParams = (url, params, options = {}) => {
  const { cache, skipNull, skipUndefined, skipEmpty } = {
    cache: true,
    skipNull: true,
    skipUndefined: true,
    skipEmpty: false,
    ...options,
  }

  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        !(skipNull && value === null) &&
        !(skipUndefined && value === undefined) &&
        !(skipEmpty && value === ''),
    ),
  )

  if (cache) filteredParams.cacheBust = Date.now().toString()

  const paramsString = new URLSearchParams(filteredParams).toString()

  return [url, paramsString].filter(Boolean).join('?')
}
